(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cs-instafeed-fixes-backup-20260702"]) return;
  try {
    
  (function () {
    var SECTION_ID = 'shopify-section-178167857891839204';
    var GAP_PX = 16;
    var MAX_TILES = 4;
    var BP_MOBILE = 700; /* below this: 2x2 grid. at or above: 4 across. */

    var lastSectionClick = 0;
    var btn = null;

    /* ===== Gap injection + 4-tile cap: find feed container and force CSS grid ===== */
    function applyGaps() {
      var section = document.getElementById(SECTION_ID);
      if (!section) return;
      var media = section.querySelectorAll('img, video');
      if (media.length < 2) return;

      // Find element with most direct children that contain media (or are media themselves)
      var allElements = section.querySelectorAll('*');
      var bestContainer = null;
      var bestCount = 0;
      allElements.forEach(function (el) {
        if (el.children.length < 2) return;
        var mediaCount = 0;
        for (var i = 0; i < el.children.length; i++) {
          var c = el.children[i];
          var tn = c.tagName;
          if (tn === 'IMG' || tn === 'VIDEO' || tn === 'PICTURE') {
            mediaCount++;
          } else if (c.querySelector('img, video, picture')) {
            mediaCount++;
          }
        }
        if (mediaCount >= 2 && mediaCount > bestCount) {
          bestCount = mediaCount;
          bestContainer = el;
        }
      });

      if (!bestContainer) return;

      // Collect media-containing direct children (the Mintt tiles)
      var mediaChildren = [];
      for (var i = 0; i < bestContainer.children.length; i++) {
        var c = bestContainer.children[i];
        var tn = c.tagName;
        var hasMedia = (tn === 'IMG' || tn === 'VIDEO' || tn === 'PICTURE') || c.querySelector('img, video, picture');
        if (hasMedia) mediaChildren.push(c);
      }

      // Cap visible tiles at MAX_TILES: hide tiles beyond the 4th
      for (var i = 0; i < mediaChildren.length; i++) {
        if (i >= MAX_TILES) {
          mediaChildren[i].style.setProperty('display', 'none', 'important');
          mediaChildren[i].setAttribute('data-cs-tile-hidden', '1');
        } else {
          mediaChildren[i].removeAttribute('data-cs-tile-hidden');
        }
      }

      var shownCount = Math.min(MAX_TILES, mediaChildren.length);

      // Responsive column count: 4 across desktop, 2x2 mobile
      var vw = window.innerWidth;
      var cols;
      if (vw < BP_MOBILE) {
        cols = Math.min(2, shownCount);
      } else {
        cols = shownCount;
      }

      // Force grid layout with explicit gap. Overrides flex, float, inline-block, table.
      bestContainer.style.setProperty('display', 'grid', 'important');
      bestContainer.style.setProperty('grid-template-columns', 'repeat(' + cols + ', 1fr)', 'important');
      bestContainer.style.setProperty('gap', GAP_PX + 'px', 'important');
      bestContainer.style.setProperty('column-gap', GAP_PX + 'px', 'important');
      bestContainer.style.setProperty('row-gap', GAP_PX + 'px', 'important');
      bestContainer.setAttribute('data-cs-gap-applied', 'true');

      // Reset any conflicting layout on visible children that might break the grid
      for (var i = 0; i < bestContainer.children.length; i++) {
        var child = bestContainer.children[i];
        if (child.getAttribute('data-cs-tile-hidden') === '1') continue;
        child.style.setProperty('float', 'none', 'important');
        child.style.setProperty('max-width', '100%', 'important');
        if (window.getComputedStyle(child).display === 'inline-block') {
          child.style.setProperty('display', 'block', 'important');
        }
      }
    }

    // Reapply on resize so column count tracks viewport changes
    var resizeT = null;
    window.addEventListener('resize', function () {
      if (resizeT) clearTimeout(resizeT);
      resizeT = setTimeout(applyGaps, 150);
    });

    /* ===== Close button: click-armed AND requires real visible modal ===== */
    var modalSelector = [
      '.instafeed-modal',
      '.instafeed-lightbox',
      '.instafeed-popup',
      '[class*="instafeed"][class*="modal"]',
      '[class*="instafeed"][class*="lightbox"]',
      '[class*="instafeed"][class*="popup"]'
    ].join(',');

    function ensureButton() {
      if (btn) return btn;
      btn = document.createElement('button');
      btn.id = 'cs-if-close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
      document.body.appendChild(btn);
      return btn;
    }

    function findOpenModal() {
      if (Date.now() - lastSectionClick > 60000) return null;
      var nodes = document.querySelectorAll(modalSelector);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.offsetWidth < 200 || n.offsetHeight < 200) continue;
        var s = window.getComputedStyle(n);
        if (s.display === 'none' || s.visibility === 'hidden') continue;
        if (parseFloat(s.opacity) < 0.1) continue;
        if (!n.querySelector('img, video, iframe')) continue;
        return n;
      }
      return null;
    }

    function closeModal() {
      var modal = findOpenModal();
      if (modal) {
        var native = modal.querySelector(
          '[class*="close"], [data-close], [aria-label*="lose" i], [aria-label*="ismiss" i]'
        );
        if (native) {
          native.click();
        } else {
          modal.style.display = 'none';
        }
        var v = modal.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
      }
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (btn) btn.classList.remove('is-open');
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(function () {});
      }
      if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }

    function syncButton() {
      ensureButton();
      if (findOpenModal()) {
        btn.classList.add('is-open');
      } else {
        btn.classList.remove('is-open');
      }
    }

    function start() {
      ensureButton();
      applyGaps();

      document.addEventListener('click', function (e) {
        var section = document.getElementById(SECTION_ID);
        if (section && section.contains(e.target)) {
          lastSectionClick = Date.now();
          [100, 300, 600, 1000, 1600, 2400].forEach(function (d) {
            setTimeout(syncButton, d);
          });
        }
      }, true);

      var section = document.getElementById(SECTION_ID);
      if (section) {
        var t = null;
        var obs = new MutationObserver(function () {
          if (t) return;
          t = setTimeout(function () {
            t = null;
            applyGaps();
            syncButton();
          }, 150);
        });
        obs.observe(section, { childList: true, subtree: true });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });

      setTimeout(applyGaps, 1000);
      setTimeout(applyGaps, 2500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-instafeed-fixes-backup-20260702b"]) return;
  try {
    
  (function () {
    var SECTION_ID = 'shopify-section-178167857891839204';
    var GAP_PX = 16;
    var MAX_TILES = 4;
    var BP_MOBILE = 700; /* below this: 2x2 grid. at or above: 4 across. */

    var lastSectionClick = 0;
    var btn = null;

    /* Find every element inside the section that qualifies as a "feed container":
       has 2+ direct children that are (or contain) media. There may be more than
       one such container on the page (e.g. a desktop copy and a mobile copy from
       the app itself) -- we no longer guess which one is "the real one", we just
       collect all of them and let applyGaps() decide per-container whether to act
       on it, based on whether it's actually visible right now. */
    function findCandidateContainers() {
      var section = document.getElementById(SECTION_ID);
      if (!section) return [];
      var media = section.querySelectorAll('img, video');
      if (media.length < 2) return [];

      var allElements = section.querySelectorAll('*');
      var candidates = [];
      allElements.forEach(function (el) {
        if (el.children.length < 2) return;
        var mediaCount = 0;
        for (var i = 0; i < el.children.length; i++) {
          var c = el.children[i];
          var tn = c.tagName;
          if (tn === 'IMG' || tn === 'VIDEO' || tn === 'PICTURE') {
            mediaCount++;
          } else if (c.querySelector('img, video, picture')) {
            mediaCount++;
          }
        }
        if (mediaCount >= 2) candidates.push(el);
      });
      return candidates;
    }

    /* Apply the grid/gap/tile-cap treatment to a single container. */
    function fixContainer(bestContainer) {
      // Collect media-containing direct children (the Mintt tiles)
      var mediaChildren = [];
      for (var i = 0; i < bestContainer.children.length; i++) {
        var c = bestContainer.children[i];
        var tn = c.tagName;
        var hasMedia = (tn === 'IMG' || tn === 'VIDEO' || tn === 'PICTURE') || c.querySelector('img, video, picture');
        if (hasMedia) mediaChildren.push(c);
      }

      // Cap visible tiles at MAX_TILES: hide tiles beyond the 4th
      for (var i = 0; i < mediaChildren.length; i++) {
        if (i >= MAX_TILES) {
          mediaChildren[i].style.setProperty('display', 'none', 'important');
          mediaChildren[i].setAttribute('data-cs-tile-hidden', '1');
        } else {
          mediaChildren[i].removeAttribute('data-cs-tile-hidden');
        }
      }

      var shownCount = Math.min(MAX_TILES, mediaChildren.length);

      // Responsive column count: 4 across desktop, 2x2 mobile
      var vw = window.innerWidth;
      var cols;
      if (vw < BP_MOBILE) {
        cols = Math.min(2, shownCount);
      } else {
        cols = shownCount;
      }

      // Force grid layout with explicit gap. Overrides flex, float, inline-block, table.
      bestContainer.style.setProperty('display', 'grid', 'important');
      bestContainer.style.setProperty('grid-template-columns', 'repeat(' + cols + ', 1fr)', 'important');
      bestContainer.style.setProperty('gap', GAP_PX + 'px', 'important');
      bestContainer.style.setProperty('column-gap', GAP_PX + 'px', 'important');
      bestContainer.style.setProperty('row-gap', GAP_PX + 'px', 'important');
      bestContainer.setAttribute('data-cs-gap-applied', 'true');

      // Reset any conflicting layout on visible children that might break the grid
      for (var i = 0; i < bestContainer.children.length; i++) {
        var child = bestContainer.children[i];
        if (child.getAttribute('data-cs-tile-hidden') === '1') continue;
        child.style.setProperty('float', 'none', 'important');
        child.style.setProperty('max-width', '100%', 'important');
        if (window.getComputedStyle(child).display === 'inline-block') {
          child.style.setProperty('display', 'block', 'important');
        }
      }
    }

    /* Run the fix on every candidate container that is currently visible on screen.
       Hidden/duplicate containers (e.g. the opposite breakpoint's copy) are left
       completely untouched -- they'll get fixed automatically once they become
       the visible one, since this whole function re-runs on resize. */
    function applyGaps() {
      var candidates = findCandidateContainers();
      candidates.forEach(function (container) {
        if (container.offsetParent === null) return; // not visible right now -- skip
        fixContainer(container);
      });
    }

    // Reapply on resize so column count tracks viewport changes, and so whichever
    // container becomes visible at the new width gets fixed.
    var resizeT = null;
    window.addEventListener('resize', function () {
      if (resizeT) clearTimeout(resizeT);
      resizeT = setTimeout(applyGaps, 150);
    });

    /* ===== Close button: click-armed AND requires real visible modal ===== */
    var modalSelector = [
      '.instafeed-modal',
      '.instafeed-lightbox',
      '.instafeed-popup',
      '[class*="instafeed"][class*="modal"]',
      '[class*="instafeed"][class*="lightbox"]',
      '[class*="instafeed"][class*="popup"]'
    ].join(',');

    function ensureButton() {
      if (btn) return btn;
      btn = document.createElement('button');
      btn.id = 'cs-if-close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
      document.body.appendChild(btn);
      return btn;
    }

    function findOpenModal() {
      if (Date.now() - lastSectionClick > 60000) return null;
      var nodes = document.querySelectorAll(modalSelector);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.offsetWidth < 200 || n.offsetHeight < 200) continue;
        var s = window.getComputedStyle(n);
        if (s.display === 'none' || s.visibility === 'hidden') continue;
        if (parseFloat(s.opacity) < 0.1) continue;
        if (!n.querySelector('img, video, iframe')) continue;
        return n;
      }
      return null;
    }

    function closeModal() {
      var modal = findOpenModal();
      if (modal) {
        var native = modal.querySelector(
          '[class*="close"], [data-close], [aria-label*="lose" i], [aria-label*="ismiss" i]'
        );
        if (native) {
          native.click();
        } else {
          modal.style.display = 'none';
        }
        var v = modal.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
      }
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (btn) btn.classList.remove('is-open');
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(function () {});
      }
      if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }

    function syncButton() {
      ensureButton();
      if (findOpenModal()) {
        btn.classList.add('is-open');
      } else {
        btn.classList.remove('is-open');
      }
    }

    function start() {
      ensureButton();
      applyGaps();

      document.addEventListener('click', function (e) {
        var section = document.getElementById(SECTION_ID);
        if (section && section.contains(e.target)) {
          lastSectionClick = Date.now();
          [100, 300, 600, 1000, 1600, 2400].forEach(function (d) {
            setTimeout(syncButton, d);
          });
        }
      }, true);

      var section = document.getElementById(SECTION_ID);
      if (section) {
        var t = null;
        var obs = new MutationObserver(function () {
          if (t) return;
          t = setTimeout(function () {
            t = null;
            applyGaps();
            syncButton();
          }, 150);
        });
        obs.observe(section, { childList: true, subtree: true });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });

      setTimeout(applyGaps, 1000);
      setTimeout(applyGaps, 2500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-instafeed-fixes-backup-20260702c"]) return;
  try {
    
  (function () {
    var SECTION_ID = 'shopify-section-178167857891839204';
    var GAP_PX = 16;
    var MAX_TILES = 4;
    var BP_SMALL = 420;  /* below this: 1 column, stacked */
    var BP_LARGE = 900;  /* at/above this: 4 columns across */
    /* between BP_SMALL and BP_LARGE: 2 columns (2x2) -- this middle tier is what
       was missing before and caused the uneven 3-then-1 wrap. */

    var lastSectionClick = 0;
    var btn = null;

    function findCandidateContainers() {
      var section = document.getElementById(SECTION_ID);
      if (!section) return [];
      var media = section.querySelectorAll('img, video');
      if (media.length < 2) return [];

      var allElements = section.querySelectorAll('*');
      var candidates = [];
      allElements.forEach(function (el) {
        if (el.children.length < 2) return;
        var mediaCount = 0;
        for (var i = 0; i < el.children.length; i++) {
          var c = el.children[i];
          var tn = c.tagName;
          if (tn === 'IMG' || tn === 'VIDEO' || tn === 'PICTURE') {
            mediaCount++;
          } else if (c.querySelector('img, video, picture')) {
            mediaCount++;
          }
        }
        if (mediaCount >= 2) candidates.push(el);
      });
      return candidates;
    }

    function fixContainer(bestContainer) {
      var mediaChildren = [];
      for (var i = 0; i < bestContainer.children.length; i++) {
        var c = bestContainer.children[i];
        var tn = c.tagName;
        var hasMedia = (tn === 'IMG' || tn === 'VIDEO' || tn === 'PICTURE') || c.querySelector('img, video, picture');
        if (hasMedia) mediaChildren.push(c);
      }

      for (var i = 0; i < mediaChildren.length; i++) {
        if (i >= MAX_TILES) {
          mediaChildren[i].style.setProperty('display', 'none', 'important');
          mediaChildren[i].setAttribute('data-cs-tile-hidden', '1');
        } else {
          mediaChildren[i].removeAttribute('data-cs-tile-hidden');
        }
      }

      var shownCount = Math.min(MAX_TILES, mediaChildren.length);

      /* Three-tier responsive column count so every row is a full row, never a
         lopsided partial one: 1 col under 420px, 2 cols 420-899px, 4 cols 900px+. */
      var vw = window.innerWidth;
      var cols;
      if (vw < BP_SMALL) {
        cols = 1;
      } else if (vw < BP_LARGE) {
        cols = Math.min(2, shownCount);
      } else {
        cols = shownCount;
      }

      bestContainer.style.setProperty('display', 'grid', 'important');
      bestContainer.style.setProperty('grid-template-columns', 'repeat(' + cols + ', 1fr)', 'important');
      bestContainer.style.setProperty('gap', GAP_PX + 'px', 'important');
      bestContainer.style.setProperty('column-gap', GAP_PX + 'px', 'important');
      bestContainer.style.setProperty('row-gap', GAP_PX + 'px', 'important');
      bestContainer.setAttribute('data-cs-gap-applied', 'true');

      for (var i = 0; i < bestContainer.children.length; i++) {
        var child = bestContainer.children[i];
        if (child.getAttribute('data-cs-tile-hidden') === '1') continue;
        child.style.setProperty('float', 'none', 'important');
        child.style.setProperty('max-width', '100%', 'important');
        if (window.getComputedStyle(child).display === 'inline-block') {
          child.style.setProperty('display', 'block', 'important');
        }
      }
    }

    function applyGaps() {
      var candidates = findCandidateContainers();
      candidates.forEach(function (container) {
        if (container.offsetParent === null) return;
        fixContainer(container);
      });
    }

    var resizeT = null;
    window.addEventListener('resize', function () {
      if (resizeT) clearTimeout(resizeT);
      resizeT = setTimeout(applyGaps, 150);
    });

    var modalSelector = [
      '.instafeed-modal',
      '.instafeed-lightbox',
      '.instafeed-popup',
      '[class*="instafeed"][class*="modal"]',
      '[class*="instafeed"][class*="lightbox"]',
      '[class*="instafeed"][class*="popup"]'
    ].join(',');

    function ensureButton() {
      if (btn) return btn;
      btn = document.createElement('button');
      btn.id = 'cs-if-close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
      document.body.appendChild(btn);
      return btn;
    }

    function findOpenModal() {
      if (Date.now() - lastSectionClick > 60000) return null;
      var nodes = document.querySelectorAll(modalSelector);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.offsetWidth < 200 || n.offsetHeight < 200) continue;
        var s = window.getComputedStyle(n);
        if (s.display === 'none' || s.visibility === 'hidden') continue;
        if (parseFloat(s.opacity) < 0.1) continue;
        if (!n.querySelector('img, video, iframe')) continue;
        return n;
      }
      return null;
    }

    function closeModal() {
      var modal = findOpenModal();
      if (modal) {
        var native = modal.querySelector(
          '[class*="close"], [data-close], [aria-label*="lose" i], [aria-label*="ismiss" i]'
        );
        if (native) {
          native.click();
        } else {
          modal.style.display = 'none';
        }
        var v = modal.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
      }
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (btn) btn.classList.remove('is-open');
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(function () {});
      }
      if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }

    function syncButton() {
      ensureButton();
      if (findOpenModal()) {
        btn.classList.add('is-open');
      } else {
        btn.classList.remove('is-open');
      }
    }

    function start() {
      ensureButton();
      applyGaps();

      document.addEventListener('click', function (e) {
        var section = document.getElementById(SECTION_ID);
        if (section && section.contains(e.target)) {
          lastSectionClick = Date.now();
          [100, 300, 600, 1000, 1600, 2400].forEach(function (d) {
            setTimeout(syncButton, d);
          });
        }
      }, true);

      var section = document.getElementById(SECTION_ID);
      if (section) {
        var t = null;
        var obs = new MutationObserver(function () {
          if (t) return;
          t = setTimeout(function () {
            t = null;
            applyGaps();
            syncButton();
          }, 150);
        });
        obs.observe(section, { childList: true, subtree: true });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });

      setTimeout(applyGaps, 1000);
      setTimeout(applyGaps, 2500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-instafeed-fixes-backup-20260702d"]) return;
  try {
    
  (function () {
    var SECTION_ID = 'shopify-section-178167857891839204';
    var GAP_PX = 16;
    var MAX_TILES = 4;
    var BP_SMALL = 420;  /* below this: 1 column, stacked */
    var BP_LARGE = 900;  /* at/above this: 4 columns across */
    /* between BP_SMALL and BP_LARGE: 2 columns (2x2) -- this middle tier is what
       was missing before and caused the uneven 3-then-1 wrap. */

    var lastSectionClick = 0;
    var btn = null;

    function findCandidateContainers() {
      var section = document.getElementById(SECTION_ID);
      if (!section) return [];
      var media = section.querySelectorAll('img, video');
      if (media.length < 2) return [];

      var allElements = section.querySelectorAll('*');
      var candidates = [];
      allElements.forEach(function (el) {
        if (el.children.length < 2) return;
        var mediaCount = 0;
        for (var i = 0; i < el.children.length; i++) {
          var c = el.children[i];
          var tn = c.tagName;
          if (tn === 'IMG' || tn === 'VIDEO' || tn === 'PICTURE') {
            mediaCount++;
          } else if (c.querySelector('img, video, picture')) {
            mediaCount++;
          }
        }
        if (mediaCount >= 2) candidates.push(el);
      });
      return candidates;
    }

    function fixContainer(bestContainer) {
      var mediaChildren = [];
      for (var i = 0; i < bestContainer.children.length; i++) {
        var c = bestContainer.children[i];
        var tn = c.tagName;
        var hasMedia = (tn === 'IMG' || tn === 'VIDEO' || tn === 'PICTURE') || c.querySelector('img, video, picture');
        if (hasMedia) mediaChildren.push(c);
      }

      for (var i = 0; i < mediaChildren.length; i++) {
        if (i >= MAX_TILES) {
          mediaChildren[i].style.setProperty('display', 'none', 'important');
          mediaChildren[i].setAttribute('data-cs-tile-hidden', '1');
        } else {
          mediaChildren[i].removeAttribute('data-cs-tile-hidden');
        }
      }

      var shownCount = Math.min(MAX_TILES, mediaChildren.length);

      /* Three-tier responsive column count so every row is a full row, never a
         lopsided partial one: 1 col under 420px, 2 cols 420-899px, 4 cols 900px+. */
      var vw = window.innerWidth;
      var cols;
      if (vw < BP_SMALL) {
        cols = 1;
      } else if (vw < BP_LARGE) {
        cols = Math.min(2, shownCount);
      } else {
        cols = shownCount;
      }

      bestContainer.style.setProperty('display', 'grid', 'important');
      bestContainer.style.setProperty('grid-template-columns', 'repeat(' + cols + ', 1fr)', 'important');
      bestContainer.style.setProperty('gap', GAP_PX + 'px', 'important');
      bestContainer.style.setProperty('column-gap', GAP_PX + 'px', 'important');
      bestContainer.style.setProperty('row-gap', GAP_PX + 'px', 'important');
      bestContainer.setAttribute('data-cs-gap-applied', 'true');

      for (var i = 0; i < bestContainer.children.length; i++) {
        var child = bestContainer.children[i];
        if (child.getAttribute('data-cs-tile-hidden') === '1') continue;
        child.style.setProperty('float', 'none', 'important');
        child.style.setProperty('max-width', '100%', 'important');
        if (window.getComputedStyle(child).display === 'inline-block') {
          child.style.setProperty('display', 'block', 'important');
        }
      }
    }

    function applyGaps() {
      var candidates = findCandidateContainers();
      candidates.forEach(function (container) {
        if (container.offsetParent === null) return;
        fixContainer(container);
      });
    }

    var resizeT = null;
    window.addEventListener('resize', function () {
      if (resizeT) clearTimeout(resizeT);
      resizeT = setTimeout(applyGaps, 150);
    });

    var modalSelector = [
      '.instafeed-modal',
      '.instafeed-lightbox',
      '.instafeed-popup',
      '[class*="instafeed"][class*="modal"]',
      '[class*="instafeed"][class*="lightbox"]',
      '[class*="instafeed"][class*="popup"]'
    ].join(',');

    function ensureButton() {
      if (btn) return btn;
      btn = document.createElement('button');
      btn.id = 'cs-if-close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
      document.body.appendChild(btn);
      return btn;
    }

    function findOpenModal() {
      if (Date.now() - lastSectionClick > 60000) return null;
      var nodes = document.querySelectorAll(modalSelector);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.offsetWidth < 200 || n.offsetHeight < 200) continue;
        var s = window.getComputedStyle(n);
        if (s.display === 'none' || s.visibility === 'hidden') continue;
        if (parseFloat(s.opacity) < 0.1) continue;
        if (!n.querySelector('img, video, iframe')) continue;
        return n;
      }
      return null;
    }

    function closeModal() {
      var modal = findOpenModal();
      if (modal) {
        var native = modal.querySelector(
          '[class*="close"], [data-close], [aria-label*="lose" i], [aria-label*="ismiss" i]'
        );
        if (native) {
          native.click();
        } else {
          modal.style.display = 'none';
        }
        var v = modal.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
      }
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (btn) btn.classList.remove('is-open');
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(function () {});
      }
      if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }

    function syncButton() {
      ensureButton();
      if (findOpenModal()) {
        btn.classList.add('is-open');
      } else {
        btn.classList.remove('is-open');
      }
    }

    function start() {
      ensureButton();
      applyGaps();

      document.addEventListener('click', function (e) {
        var section = document.getElementById(SECTION_ID);
        if (section && section.contains(e.target)) {
          lastSectionClick = Date.now();
          [100, 300, 600, 1000, 1600, 2400].forEach(function (d) {
            setTimeout(syncButton, d);
          });
        }
      }, true);

      var section = document.getElementById(SECTION_ID);
      if (section) {
        var t = null;
        var obs = new MutationObserver(function () {
          if (t) return;
          t = setTimeout(function () {
            t = null;
            applyGaps();
            syncButton();
          }, 150);
        });
        obs.observe(section, { childList: true, subtree: true });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });

      setTimeout(applyGaps, 1000);
      setTimeout(applyGaps, 2500);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-instafeed-fixes-backup-20260702e"]) return;
  try {
    
  (function () {
    var SECTION_ID = 'shopify-section-178167857891839204';
    var GAP_PX = 16;
    var HALF_GAP = GAP_PX / 2;
    var MAX_TILES = 4;

    var lastSectionClick = 0;
    var btn = null;

    function isMediaTag(tn) {
      return tn === 'IMG' || tn === 'VIDEO' || tn === 'PICTURE' || tn === 'IFRAME' || tn === 'BLOCKQUOTE';
    }
    function isMediaTile(c) {
      if (isMediaTag(c.tagName)) return true;
      if (c.querySelector && c.querySelector('img, video, picture, iframe, blockquote')) return true;
      if (c.classList && c.classList.contains('instagram-media')) return true;
      if (c.className && /instagram/i.test(c.className)) return true;
      if (c.querySelector && c.querySelector('.instagram-media, [class*="instagram"]')) return true;
      return false;
    }

    function findCandidateContainers() {
      var section = document.getElementById(SECTION_ID);
      if (!section) return [];
      var media = section.querySelectorAll('img, video, iframe, blockquote, [class*="instagram"]');
      if (media.length < 2) return [];

      var allElements = section.querySelectorAll('*');
      var candidates = [];
      allElements.forEach(function (el) {
        if (el.children.length < 2) return;
        var mediaCount = 0;
        for (var i = 0; i < el.children.length; i++) {
          if (isMediaTile(el.children[i])) mediaCount++;
        }
        if (mediaCount >= 2) candidates.push(el);
      });
      return candidates;
    }

    /* Spacing-only pass: does NOT touch display/layout mode on the container or
       its children at all. Just gives each visible tile a margin on every side,
       which creates a visual gap between neighbors regardless of whether the
       container is flex, grid, inline-block, or anything else. Also caps at
       MAX_TILES by hiding extras (display:none on the TILE itself is safe --
       it's the container's layout mode that was risky to touch, not this). */
    function spaceContainer(container) {
      var mediaChildren = [];
      for (var i = 0; i < container.children.length; i++) {
        var c = container.children[i];
        if (isMediaTile(c)) mediaChildren.push(c);
      }

      for (var i = 0; i < mediaChildren.length; i++) {
        var tile = mediaChildren[i];
        if (i >= MAX_TILES) {
          tile.style.setProperty('display', 'none', 'important');
          tile.setAttribute('data-cs-tile-hidden', '1');
          continue;
        }
        tile.removeAttribute('data-cs-tile-hidden');
        tile.style.setProperty('margin', HALF_GAP + 'px', 'important');
        tile.style.setProperty('box-sizing', 'border-box', 'important');
      }

      /* Counteract the container's own edge padding so the outer row still lines
         up with the rest of the page (margins on the first/last tile would
         otherwise push the whole row in from the container's true edge). */
      container.style.setProperty('margin-left', '-' + HALF_GAP + 'px', 'important');
      container.style.setProperty('margin-right', '-' + HALF_GAP + 'px', 'important');
    }

    function applySpacing() {
      var candidates = findCandidateContainers();
      candidates.forEach(function (container) {
        if (container.offsetParent === null) return;
        spaceContainer(container);
      });
    }

    var resizeT = null;
    window.addEventListener('resize', function () {
      if (resizeT) clearTimeout(resizeT);
      resizeT = setTimeout(applySpacing, 150);
    });

    var modalSelector = [
      '.instafeed-modal',
      '.instafeed-lightbox',
      '.instafeed-popup',
      '[class*="instafeed"][class*="modal"]',
      '[class*="instafeed"][class*="lightbox"]',
      '[class*="instafeed"][class*="popup"]'
    ].join(',');

    function ensureButton() {
      if (btn) return btn;
      btn = document.createElement('button');
      btn.id = 'cs-if-close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
      document.body.appendChild(btn);
      return btn;
    }

    function findOpenModal() {
      if (Date.now() - lastSectionClick > 60000) return null;
      var nodes = document.querySelectorAll(modalSelector);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.offsetWidth < 200 || n.offsetHeight < 200) continue;
        var s = window.getComputedStyle(n);
        if (s.display === 'none' || s.visibility === 'hidden') continue;
        if (parseFloat(s.opacity) < 0.1) continue;
        if (!n.querySelector('img, video, iframe')) continue;
        return n;
      }
      return null;
    }

    function closeModal() {
      var modal = findOpenModal();
      if (modal) {
        var native = modal.querySelector(
          '[class*="close"], [data-close], [aria-label*="lose" i], [aria-label*="ismiss" i]'
        );
        if (native) {
          native.click();
        } else {
          modal.style.display = 'none';
        }
        var v = modal.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
      }
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (btn) btn.classList.remove('is-open');
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(function () {});
      }
      if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }

    function syncButton() {
      ensureButton();
      if (findOpenModal()) {
        btn.classList.add('is-open');
      } else {
        btn.classList.remove('is-open');
      }
    }

    function start() {
      ensureButton();
      applySpacing();

      document.addEventListener('click', function (e) {
        var section = document.getElementById(SECTION_ID);
        if (section && section.contains(e.target)) {
          lastSectionClick = Date.now();
          [100, 300, 600, 1000, 1600, 2400].forEach(function (d) {
            setTimeout(syncButton, d);
          });
        }
      }, true);

      var section = document.getElementById(SECTION_ID);
      if (section) {
        var t = null;
        var obs = new MutationObserver(function () {
          if (t) return;
          t = setTimeout(function () {
            t = null;
            applySpacing();
            syncButton();
          }, 150);
        });
        obs.observe(section, { childList: true, subtree: true });
      }

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });

      /* Instagram's embed.js swaps blockquote -> iframe asynchronously, so keep
         re-checking for a while after load -- but each check only ever adds
         margin, never changes display/layout, so there's nothing here that can
         interfere with the embed's own initialization. */
      [500, 1000, 1500, 2000, 3000, 4000, 6000, 9000].forEach(function (d) {
        setTimeout(applySpacing, d);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-instafeed-fixes-backup-20260702f"]) return;
  try {
    
  (function () {
    var lastSectionClick = 0;
    var btn = null;

    var modalSelector = [
      '.instafeed-modal',
      '.instafeed-lightbox',
      '.instafeed-popup',
      '[class*="instafeed"][class*="modal"]',
      '[class*="instafeed"][class*="lightbox"]',
      '[class*="instafeed"][class*="popup"]'
    ].join(',');

    function ensureButton() {
      if (btn) return btn;
      btn = document.createElement('button');
      btn.id = 'cs-if-close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
      document.body.appendChild(btn);
      return btn;
    }

    function findOpenModal() {
      if (Date.now() - lastSectionClick > 60000) return null;
      var nodes = document.querySelectorAll(modalSelector);
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.offsetWidth < 200 || n.offsetHeight < 200) continue;
        var s = window.getComputedStyle(n);
        if (s.display === 'none' || s.visibility === 'hidden') continue;
        if (parseFloat(s.opacity) < 0.1) continue;
        if (!n.querySelector('img, video, iframe')) continue;
        return n;
      }
      return null;
    }

    function closeModal() {
      var modal = findOpenModal();
      if (modal) {
        var native = modal.querySelector(
          '[class*="close"], [data-close], [aria-label*="lose" i], [aria-label*="ismiss" i]'
        );
        if (native) {
          native.click();
        } else {
          modal.style.display = 'none';
        }
        var v = modal.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
      }
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (btn) btn.classList.remove('is-open');
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(function () {});
      }
      if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }

    function syncButton() {
      ensureButton();
      if (findOpenModal()) {
        btn.classList.add('is-open');
      } else {
        btn.classList.remove('is-open');
      }
    }

    function start() {
      ensureButton();

      document.addEventListener('click', function (e) {
        var wrapper = document.querySelector('.instafeed-new-layout-wrapper');
        if (wrapper && wrapper.contains(e.target)) {
          lastSectionClick = Date.now();
          [100, 300, 600, 1000, 1600, 2400].forEach(function (d) {
            setTimeout(syncButton, d);
          });
        }
      }, true);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cs-instafeed-fixes"]) return;
  try {
    
  (function () {
    var lastSectionClick = 0;
    var btn = null;

    var modalSelector = [
      '.instafeed-modal',
      '.instafeed-lightbox',
      '.instafeed-popup',
      '[class*="instafeed"][class*="modal"]',
      '[class*="instafeed"][class*="lightbox"]',
      '[class*="instafeed"][class*="popup"]'
    ].join(',');

    function ensureButton() {
      if (btn) return btn;
      btn = document.createElement('button');
      btn.id = 'cs-if-close';
      btn.setAttribute('aria-label', 'Close');
      btn.innerHTML = '&times;';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });
      document.body.appendChild(btn);
      return btn;
    }

    function findOpenModal() {
      if (Date.now() - lastSectionClick > 60000) return null;
      var nodes = document.querySelectorAll(modalSelector);
      for (var i = 0; nodes.length > i; i++) {
        var n = nodes[i];
        if (200 > n.offsetWidth || 200 > n.offsetHeight) continue;
        var s = window.getComputedStyle(n);
        if (s.display === 'none' || s.visibility === 'hidden') continue;
        if (0.1 > parseFloat(s.opacity)) continue;
        if (!n.querySelector('img, video, iframe')) continue;
        return n;
      }
      return null;
    }

    function closeModal() {
      var modal = findOpenModal();
      if (modal) {
        var native = modal.querySelector(
          '[class*="close"], [data-close], [aria-label*="lose" i], [aria-label*="ismiss" i]'
        );
        if (native) {
          native.click();
        } else {
          modal.style.display = 'none';
        }
        var v = modal.querySelector('video');
        if (v) { try { v.pause(); } catch (e) {} }
      }
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      if (btn) btn.classList.remove('is-open');
      if (document.fullscreenElement && document.exitFullscreen) {
        document.exitFullscreen().catch(function () {});
      }
      if (document.webkitFullscreenElement && document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    }

    function syncButton() {
      ensureButton();
      if (findOpenModal()) {
        btn.classList.add('is-open');
      } else {
        btn.classList.remove('is-open');
      }
    }

    function start() {
      ensureButton();

      document.addEventListener('click', function (e) {
        var wrapper = document.querySelector('.instafeed-new-layout-wrapper');
        if (wrapper && wrapper.contains(e.target)) {
          lastSectionClick = Date.now();
          [100, 300, 600, 1000, 1600, 2400].forEach(function (d) {
            setTimeout(syncButton, d);
          });
        }
      }, true);

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeModal();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
